import {Image, Integer} from 'platform/foundation';
import {match} from 'ts-pattern';

import {isEmpty, isNil} from 'ramda';

import {Nullish, TestIdProps} from 'shared/web';

import {useVehicleTranslatedInfo} from '../../hooks/useVehicleTranslatedInfo';

interface VehicleLogoProps extends TestIdProps {
  vehicle: {
    make?: string | Nullish;
    modelFamily?: string | Nullish;
    vehicleType?: string | Nullish;
  };
  height?: Integer;
  width?: Integer;
  color?: 'white' | 'black' | 'default';
}

export function VehicleLogo(props: VehicleLogoProps) {
  const {data} = useVehicleTranslatedInfo(props.vehicle);

  const logoUrl = match(props.color ?? 'default')
    .with('default', () => data.logoUrl)
    .with('white', () => data.whiteLogoUrl)
    .with('black', () => data.blackLogoUrl)
    .exhaustive();

  if (isNil(logoUrl) || isEmpty(logoUrl)) {
    return null;
  }

  return (
    <Image
      src={logoUrl}
      height={props.height}
      width={props.width}
      fit="contain"
      data-testid={props['data-testid']}
    />
  );
}
